import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrdersDataService {
  private baseUrl = environment.WS_URL + '/api/v1';
  private apiUrl = this.baseUrl + '/coffee/sale-orders/';

  constructor(private http: HttpClient) { }

  getOrders(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  postData(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data);
  }

  getOrder(id:number): Observable<any> {
    return this.http.get<any>(this.apiUrl + id);
  }

  getInventoryForOrders(id?:number, locationid?:number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/coffee/for-orders/inventory/' + id + '/' + locationid + '/');
  }

  createOrder(json:any) {
    return this.http.post<number>(this.baseUrl + '/coffee/sales-order/create/', json);    
  }

  createOrderDetail(json:any) {
    return this.http.post<any>(this.baseUrl + '/coffee/sales-order/detail/create/', json);    
  }

  updateOrder(json:any) {
    return this.http.post<any>(this.baseUrl + '/coffee/sales-order/update/', json);       
  }

  updateOrderDetail(json:any[]) {
    return this.http.post<any>(this.baseUrl + '/coffee/sales-order/detail/update/', json);        
  }

}
